module.exports = __webpack_public_path__ + "img/2.ee02eee9.png";